// OurCars.jsx
// Drop into your src/pages/ (or src/) folder.
// Uses the same CSS variables & font stack as your landing page.

import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
// ─── MOCK / FALLBACK DATA ─────────────────────────────────────
// const API_BASE = "http://localhost:5000/api";
const API_BASE = "http://192.168.0.57:5000/api";
const mockVehicles = [
  { car_id:1,  car_name:"Tesla Model S",    car_brand:"Tesla",    cat_name:"Electric",    group_name:"Premium",  car_passgrno:5, car_luggno:3, car_doors:4, car_transmission:"Automatic", car_airconditionr:"Yes", car_engcapacity:0,    car_powrsteering:"Yes", car_cntralLocking:"Yes", car_stereo:"Yes", car_airbag:"Yes", car_elctricwindows:"Yes", car_image:"https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=700&q=80", car_dispinhome:1, car_desc:"Smooth, silent, and lightning fast — redefine every commute.", price:89,  badge:"Popular" },
  { car_id:2,  car_name:"BMW X5",           car_brand:"BMW",      cat_name:"SUV",         group_name:"Luxury",   car_passgrno:7, car_luggno:4, car_doors:4, car_transmission:"Automatic", car_airconditionr:"Yes", car_engcapacity:2998, car_powrsteering:"Yes", car_cntralLocking:"Yes", car_stereo:"Yes", car_airbag:"Yes", car_elctricwindows:"Yes", car_image:"https://images.unsplash.com/photo-1555215695-3004980ad54e?w=700&q=80", car_dispinhome:1, car_desc:"Command every road with confidence and supreme comfort.", price:110, badge:"Luxury" },
  { car_id:3,  car_name:"Toyota Corolla",   car_brand:"Toyota",   cat_name:"Sedan",       group_name:"Economy",  car_passgrno:5, car_luggno:2, car_doors:4, car_transmission:"Automatic", car_airconditionr:"Yes", car_engcapacity:1800, car_powrsteering:"Yes", car_cntralLocking:"Yes", car_stereo:"Yes", car_airbag:"Yes", car_elctricwindows:"Yes", car_image:"https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=700&q=80", car_dispinhome:1, car_desc:"Reliable, fuel-efficient, and perfect for city and highway.",  price:45,  badge:"Economy" },
  { car_id:4,  car_name:"Jeep Wrangler",    car_brand:"Jeep",     cat_name:"4×4",         group_name:"Off-Road", car_passgrno:5, car_luggno:3, car_doors:4, car_transmission:"Manual",    car_airconditionr:"Yes", car_engcapacity:3604, car_powrsteering:"Yes", car_cntralLocking:"Yes", car_stereo:"Yes", car_airbag:"Yes", car_elctricwindows:"Yes", car_image:"https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=700&q=80", car_dispinhome:1, car_desc:"Conquer any terrain — dunes, mountains, or jungle trails.",   price:75,  badge:"Off-Road" },
  { car_id:5,  car_name:"Mercedes GLA",     car_brand:"Mercedes", cat_name:"Compact SUV", group_name:"Premium",  car_passgrno:5, car_luggno:3, car_doors:4, car_transmission:"Automatic", car_airconditionr:"Yes", car_engcapacity:1991, car_powrsteering:"Yes", car_cntralLocking:"Yes", car_stereo:"Yes", car_airbag:"Yes", car_elctricwindows:"Yes", car_image:"https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=700&q=80", car_dispinhome:1, car_desc:"German engineering meets urban elegance in every journey.",    price:95,  badge:"New" },
  { car_id:6,  car_name:"VW Polo",          car_brand:"Volkswagen",cat_name:"Hatchback",  group_name:"Economy",  car_passgrno:5, car_luggno:2, car_doors:4, car_transmission:"Manual",    car_airconditionr:"Yes", car_engcapacity:999,  car_powrsteering:"Yes", car_cntralLocking:"Yes", car_stereo:"Yes", car_airbag:"Yes", car_elctricwindows:"Yes", car_image:"https://images.unsplash.com/photo-1541899481282-d53bffe3c35d?w=700&q=80", car_dispinhome:1, car_desc:"Nimble, economical, and surprisingly fun for everyday trips.", price:35,  badge:"Budget" },
  { car_id:7,  car_name:"Hyundai Creta",    car_brand:"Hyundai",  cat_name:"Compact SUV", group_name:"Mid-Range",car_passgrno:5, car_luggno:3, car_doors:4, car_transmission:"Automatic", car_airconditionr:"Yes", car_engcapacity:1497, car_powrsteering:"Yes", car_cntralLocking:"Yes", car_stereo:"Yes", car_airbag:"Yes", car_elctricwindows:"Yes", car_image:"https://images.unsplash.com/photo-1609520778703-4f2b0f28e7e5?w=700&q=80", car_dispinhome:1, car_desc:"India's favourite SUV — stylish, spacious, and value-packed.",  price:58,  badge:"Popular" },
  { car_id:8,  car_name:"Fortuner",         car_brand:"Toyota",   cat_name:"SUV",         group_name:"Luxury",   car_passgrno:7, car_luggno:5, car_doors:4, car_transmission:"Automatic", car_airconditionr:"Yes", car_engcapacity:2755, car_powrsteering:"Yes", car_cntralLocking:"Yes", car_stereo:"Yes", car_airbag:"Yes", car_elctricwindows:"Yes", car_image:"https://images.unsplash.com/photo-1627613591339-13560e1ef4b9?w=700&q=80", car_dispinhome:1, car_desc:"7-seat SUV that towers above the crowd in presence and power.",   price:130, badge:"Luxury" },
  { car_id:9,  car_name:"Mahindra Thar",    car_brand:"Mahindra", cat_name:"4×4",         group_name:"Off-Road", car_passgrno:4, car_luggno:2, car_doors:4, car_transmission:"Manual",    car_airconditionr:"Yes", car_engcapacity:2184, car_powrsteering:"Yes", car_cntralLocking:"No",  car_stereo:"Yes", car_airbag:"Yes", car_elctricwindows:"No",  car_image:"https://images.unsplash.com/photo-1597007030739-6d2e6a630f95?w=700&q=80", car_dispinhome:1, car_desc:"India's iconic off-roader — raw, capable, and unforgettable.",  price:62,  badge:"Off-Road" },
];

const mockCarGroups = [
  { group_id:1, group_name:"Economy" },
  { group_id:2, group_name:"Mid-Range" },
  { group_id:3, group_name:"Premium" },
  { group_id:4, group_name:"Luxury" },
  { group_id:5, group_name:"Off-Road" },
];

function useFetch(endpoint, fallback) {
  const [data, setData]     = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch(`${API_BASE}${endpoint}`)
      .then(r => r.json())
      .then(d => {
        if (Array.isArray(d))            setData(d);
        else if (Array.isArray(d?.data)) setData(d.data);
        else if (typeof d === "object")  setData(d);
        else                             setData(fallback);
        setLoading(false);
      })
      .catch(() => { setData(fallback); setLoading(false); });
  }, [endpoint]);
  return { data, loading };
}

// ─── INLINE CSS (same token system as landing page) ───────────
const css = `
  /* ── OurCars page tokens ── */
  :root {
    --gold: #C9A84C;
    --gold-light: #E8C97A;
    --dark: #0A0A0F;
    --dark2: #111118;
    --dark3: #1A1A24;
    --surface: #16161F;
    --border: rgba(201,168,76,0.18);
    --text: #E8E8F0;
    --muted: #7A7A9A;
    --white: #FFFFFF;
    --radius: 12px;
  }

  /* ── NAV (copied from landing) ── */
  .oc-nav {
    position:fixed; top:0; left:0; right:0; z-index:1000;
    display:flex; align-items:center; justify-content:space-between;
    padding:0 5%; height:72px;
    background:rgba(10,10,15,0.96); backdrop-filter:blur(18px);
    border-bottom:1px solid var(--border);
  }
  .oc-nav-logo { font-family:'Playfair Display',serif; font-size:1.6rem; color:var(--gold); letter-spacing:-0.5px; cursor:pointer; }
  .oc-nav-logo span { color:var(--white); }
  .oc-nav-links { display:flex; gap:2rem; list-style:none; }
  .oc-nav-links a { color:var(--muted); text-decoration:none; font-size:.9rem; font-weight:500; letter-spacing:.5px; transition:color .2s; }
  .oc-nav-links a:hover, .oc-nav-links a.active { color:var(--gold); }
  .oc-nav-cta { background:var(--gold); color:var(--dark); font-weight:600; font-size:.85rem; padding:.55rem 1.4rem; border:none; border-radius:8px; cursor:pointer; transition:background .2s; }
  .oc-nav-cta:hover { background:var(--gold-light); }
  .oc-mobile-toggle { display:none; flex-direction:column; gap:5px; cursor:pointer; background:none; border:none; padding:4px; }
  .oc-mobile-toggle span { display:block; width:24px; height:2px; background:var(--gold); border-radius:2px; transition:all .3s; }
  .oc-mobile-menu {
    display:none; position:fixed; top:72px; left:0; right:0; z-index:999;
    background:rgba(10,10,15,0.98); backdrop-filter:blur(18px);
    border-bottom:1px solid var(--border); padding:1.5rem 5%; flex-direction:column;
  }
  .oc-mobile-menu.open { display:flex; }
  .oc-mobile-menu a { color:var(--muted); text-decoration:none; font-size:1rem; font-weight:500; padding:.9rem 0; border-bottom:1px solid var(--border); display:block; transition:color .2s; }
  .oc-mobile-menu a:hover { color:var(--gold); }
  .oc-mobile-menu .oc-nav-cta { margin-top:1rem; width:100%; text-align:center; padding:.7rem; font-size:.95rem; }

  /* ── PAGE HERO ── */
  .oc-hero {
    padding: 120px 5% 60px;
    background: var(--dark2);
    border-bottom: 1px solid var(--border);
    position: relative;
    overflow: hidden;
  }
  .oc-hero::before {
    content:'';
    position:absolute; inset:0;
    background: radial-gradient(ellipse 60% 80% at 70% 50%, rgba(201,168,76,.07) 0%, transparent 70%);
    pointer-events:none;
  }
  .oc-hero-inner { position:relative; }
  .oc-hero-label { font-size:.72rem; letter-spacing:3px; text-transform:uppercase; color:var(--gold); margin-bottom:.8rem; }
  .oc-hero-title { font-family:'Playfair Display',serif; font-size:clamp(2rem,5vw,3.8rem); color:var(--white); line-height:1.1; margin-bottom:1rem; }
  .oc-hero-title span { color:var(--gold); }
  .oc-hero-desc { color:var(--muted); font-size:.95rem; line-height:1.7; max-width:520px; }

  /* ── BOOKING STRIP (mini re-booking bar) ── */
  .oc-booking-strip {
    background:var(--surface);
    border-bottom:1px solid var(--border);
    padding:1.2rem 5%;
    display:flex; gap:1rem; align-items:center; flex-wrap:wrap;
    font-size:.82rem; color:var(--muted);
  }
  .oc-booking-strip strong { color:var(--gold); }
  .oc-modify-btn {
    margin-left:auto;
    background:transparent; color:var(--gold);
    border:1px solid var(--gold); padding:.45rem 1.1rem;
    border-radius:8px; cursor:pointer; font-size:.82rem; font-weight:600;
    transition:all .2s; white-space:nowrap;
  }
  .oc-modify-btn:hover { background:var(--gold); color:var(--dark); }

  /* ── LAYOUT ── */
  .oc-layout { display:flex; gap:2rem; padding:2.5rem 5% 4rem; align-items:flex-start; }

  /* ── SIDEBAR ── */
  .oc-sidebar {
    width:270px; flex-shrink:0;
    background:var(--surface); border:1px solid var(--border);
    border-radius:16px; padding:1.8rem;
    position:sticky; top:88px; align-self:flex-start;
  }
  .oc-sidebar h3 {
    font-family:'Playfair Display',serif; font-size:1.05rem; color:var(--white);
    margin-bottom:1.4rem; padding-bottom:.8rem; border-bottom:1px solid var(--border);
    display:flex; justify-content:space-between; align-items:center;
  }
  .oc-sidebar h3 button {
    font-family:'DM Sans',sans-serif; font-size:.72rem; color:var(--gold);
    background:none; border:none; cursor:pointer; font-weight:600; letter-spacing:.5px;
  }
  .oc-filter-group { margin-bottom:1.6rem; }
  .oc-filter-label { font-size:.72rem; letter-spacing:1.5px; text-transform:uppercase; color:var(--gold); font-weight:600; margin-bottom:.75rem; display:block; }
  .oc-filter-option {
    display:flex; align-items:center; gap:.5rem;
    font-size:.875rem; color:var(--muted); padding:.4rem 0; cursor:pointer;
    transition:color .2s;
  }
  .oc-filter-option:hover { color:var(--text); }
  .oc-filter-option input[type="checkbox"] { accent-color:var(--gold); width:15px; height:15px; cursor:pointer; flex-shrink:0; }
  .oc-filter-option input[type="checkbox"]:checked + span { color:var(--text); }
  .oc-filter-range { width:100%; accent-color:var(--gold); cursor:pointer; }
  .oc-range-labels { display:flex; justify-content:space-between; font-size:.75rem; color:var(--muted); margin-top:.35rem; }

  /* ── CAR GRID ── */
  .oc-main { flex:1; min-width:0; }
  .oc-toolbar {
    display:flex; justify-content:space-between; align-items:center;
    margin-bottom:1.5rem; flex-wrap:wrap; gap:1rem;
  }
  .oc-count { font-size:.9rem; color:var(--muted); }
  .oc-count strong { color:var(--text); }
  .oc-sort {
    background:var(--surface); border:1px solid var(--border);
    color:var(--text); padding:.55rem 1rem; border-radius:8px;
    font-size:.85rem; font-family:inherit; outline:none; cursor:pointer;
    appearance:none;
  }
  .oc-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(290px,1fr)); gap:1.5rem; }

  /* ── CAR CARD ── */
  .oc-card {
    background:var(--surface); border:1px solid var(--border);
    border-radius:16px; overflow:hidden;
    transition:border-color .3s, transform .3s, box-shadow .3s;
    cursor:pointer; display:flex; flex-direction:column;
  }
  .oc-card:hover {
    border-color:var(--gold); transform:translateY(-5px);
    box-shadow:0 24px 60px rgba(0,0,0,.45);
  }
  .oc-card-img-wrap { position:relative; height:200px; overflow:hidden; }
  .oc-card-img-wrap img { width:100%; height:100%; object-fit:cover; transition:transform .5s ease; }
  .oc-card:hover .oc-card-img-wrap img { transform:scale(1.06); }
  .oc-card-badge {
    position:absolute; top:1rem; left:1rem;
    background:var(--gold); color:var(--dark);
    font-size:.7rem; font-weight:700; padding:.28rem .75rem;
    border-radius:20px; letter-spacing:.5px;
  }
  .oc-card-body { padding:1.4rem; flex:1; display:flex; flex-direction:column; }
  .oc-card-group { font-size:.75rem; color:var(--gold); font-weight:600; letter-spacing:1px; text-transform:uppercase; margin-bottom:.3rem; }
  .oc-card-name { font-family:'Playfair Display',serif; font-size:1.15rem; color:var(--white); margin-bottom:.2rem; }
  .oc-card-brand { font-size:.82rem; color:var(--muted); margin-bottom:1rem; }
  .oc-card-specs {
    display:grid; grid-template-columns:1fr 1fr; gap:.4rem .6rem;
    margin-bottom:1.1rem;
  }
  .oc-spec { display:flex; align-items:center; gap:.4rem; font-size:.78rem; color:var(--muted); }
  .oc-spec-icon { font-size:.9rem; flex-shrink:0; }
  .oc-card-desc { font-size:.82rem; color:var(--muted); line-height:1.55; margin-bottom:1.2rem; flex:1;
    display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; }
  .oc-card-footer { display:flex; align-items:center; justify-content:space-between; padding-top:1rem; border-top:1px solid var(--border); margin-top:auto; }
  .oc-card-price { color:var(--gold); font-weight:700; font-size:1.15rem; }
  .oc-card-price small { color:var(--muted); font-size:.72rem; font-weight:400; display:block; }
  .oc-book-btn {
    background:var(--gold); color:var(--dark); font-weight:700;
    padding:.5rem 1.2rem; border:none; border-radius:8px;
    font-size:.82rem; cursor:pointer; transition:all .2s;
  }
  .oc-book-btn:hover { background:var(--gold-light); }
  .oc-details-btn {
    background:transparent; color:var(--gold);
    border:1px solid var(--gold); padding:.5rem 1rem;
    border-radius:8px; font-size:.82rem; font-weight:600;
    cursor:pointer; transition:all .2s;
  }
  .oc-details-btn:hover { background:var(--gold); color:var(--dark); }

  /* ── NO RESULTS ── */
  .oc-empty { text-align:center; padding:5rem 2rem; color:var(--muted); }
  .oc-empty-icon { font-size:3.5rem; margin-bottom:1rem; opacity:.5; }
  .oc-empty h3 { font-family:'Playfair Display',serif; font-size:1.5rem; color:var(--white); margin-bottom:.5rem; }

  /* ── MODAL OVERLAY ── */
  .oc-modal-bg {
    position:fixed; inset:0; z-index:2000;
    background:rgba(10,10,15,.88); backdrop-filter:blur(10px);
    display:flex; align-items:center; justify-content:center; padding:1.5rem;
    animation:fadeIn .25s ease;
  }
  @keyframes fadeIn { from{opacity:0} to{opacity:1} }
  .oc-modal {
    background:var(--dark3); border:1px solid var(--border); border-radius:20px;
    width:100%; max-width:780px; max-height:90vh; overflow-y:auto;
    animation:slideUp .3s ease;
  }
  @keyframes slideUp { from{opacity:0;transform:translateY(30px)} to{opacity:1;transform:translateY(0)} }
  .oc-modal-header {
    display:flex; justify-content:space-between; align-items:center;
    padding:1.6rem 2rem; border-bottom:1px solid var(--border);
    position:sticky; top:0; background:var(--dark3); z-index:1;
  }
  .oc-modal-header h2 { font-family:'Playfair Display',serif; font-size:1.4rem; color:var(--white); }
  .oc-modal-close {
    width:36px; height:36px; border-radius:50%;
    background:var(--surface); border:1px solid var(--border);
    color:var(--muted); font-size:1.2rem; cursor:pointer; transition:all .2s;
    display:flex; align-items:center; justify-content:center; flex-shrink:0;
  }
  .oc-modal-close:hover { background:var(--gold); color:var(--dark); border-color:var(--gold); }
  .oc-modal-body { padding:2rem; }
  .oc-modal-img { width:100%; height:260px; object-fit:cover; border-radius:12px; margin-bottom:1.8rem; }
  .oc-modal-grid { display:grid; grid-template-columns:1fr 1fr; gap:2rem; }
  .oc-modal-spec-group h4 { font-size:.72rem; letter-spacing:2px; text-transform:uppercase; color:var(--gold); margin-bottom:1rem; font-weight:600; }
  .oc-modal-spec-row {
    display:flex; align-items:center; gap:.65rem;
    padding:.65rem 0; border-bottom:1px solid var(--border);
    font-size:.88rem; color:var(--text);
  }
  .oc-modal-spec-row:last-child { border-bottom:none; }
  .oc-modal-spec-row .icon { font-size:1rem; width:22px; flex-shrink:0; text-align:center; }
  .oc-modal-spec-row .val { margin-left:auto; color:var(--muted); font-size:.82rem; }
  .oc-modal-desc { color:var(--muted); font-size:.9rem; line-height:1.7; margin-bottom:1.8rem; margin-top:-.6rem; }
  .oc-modal-footer { padding:1.4rem 2rem; border-top:1px solid var(--border); display:flex; justify-content:space-between; align-items:center; gap:1rem; }
  .oc-modal-price { font-family:'Playfair Display',serif; font-size:1.8rem; color:var(--gold); }
  .oc-modal-price small { font-family:'DM Sans',sans-serif; font-size:.8rem; color:var(--muted); font-weight:400; }
  .oc-modal-book { background:var(--gold); color:var(--dark); font-weight:700; padding:.75rem 2.2rem; border:none; border-radius:10px; font-size:1rem; cursor:pointer; transition:all .25s; }
  .oc-modal-book:hover { background:var(--gold-light); transform:translateY(-2px); box-shadow:0 10px 30px rgba(201,168,76,.3); }

  /* ── PAGINATION ── */
  .oc-pagination { display:flex; justify-content:center; gap:.5rem; margin-top:3rem; flex-wrap:wrap; }
  .oc-page-btn {
    width:40px; height:40px; border-radius:8px;
    border:1px solid var(--border); background:var(--surface);
    color:var(--text); cursor:pointer; font-size:.88rem;
    transition:all .2s; font-family:inherit;
  }
  .oc-page-btn:hover { border-color:var(--gold); color:var(--gold); }
  .oc-page-btn.active { background:var(--gold); color:var(--dark); border-color:var(--gold); font-weight:700; }
  .oc-page-btn:disabled { opacity:.35; cursor:not-allowed; }

  /* ── RESPONSIVE ── */
  @media (max-width:900px) {
    .oc-layout { flex-direction:column; }
    .oc-sidebar { width:86%; position:static; }
    .oc-grid { grid-template-columns:repeat(auto-fill,minmax(260px,1fr)); }
    .oc-modal-grid { grid-template-columns:1fr; }
  }
  @media (max-width:768px) {
    .oc-nav-links, .oc-nav-cta { display:none; }
    .oc-mobile-toggle { display:flex; }
    .oc-hero { padding:96px 4% 48px; }
    .oc-layout { padding:2rem 4% 3rem; }
    .oc-booking-strip { padding:1rem 4%; font-size:.8rem; }
    .oc-sidebar { padding:1.4rem; }
  }
  @media (max-width:500px) {
    .oc-grid { grid-template-columns:1fr; }
    .oc-modal-body { padding:1.4rem; }
    .oc-modal-header { padding:1.2rem 1.4rem; }
    .oc-modal-footer { flex-direction:column; text-align:center; }
    .oc-modal-book { width:100%; }
    .oc-hero-title { font-size:1.9rem; }
  }
`;

// ─── HELPERS ─────────────────────────────────────────────────

/**
 * Extracts the display price from a car object.
 *
 * Your PHP backend stores the final price in different field names
 * depending on whether discount exists:
 *   - tbl_innertariff  → `discount`  (used when discount > 0)
 *   - tbl_tariffs      → `price`     (base per-day price)
 *
 * The Node/Express API may expose any of these field names.
 * We try every known variant and return the first numeric value found.
 */
const getPrice = (car) => {
  const candidates = [
    car.discount,       // discounted price (PHP: $discount)
    car.priceperday,    // PHP: $priceperday
    car.perdayprice,    // PHP: $perdayprice
    car.price,          // tbl_tariffs.price / mock data
    car.tar_price,      // some Node APIs expose as tar_price
    car.min_price,      // aggregated minimum
    car.base_price,
    car.daily_rate,
    car.rate,
  ];
  for (const v of candidates) {
    const n = parseFloat(v);
    if (!isNaN(n) && n > 0) return n;
  }
  return null;
};

const getImg = (img) => {
  if (!img || img === "" || img === "default.jpg")
    return "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=700&q=80";
  if (img.startsWith("http")) return img;
  return `${API_BASE.replace("/api", "")}/${img}`;
};

const TRANSMISSIONS = ["Automatic", "Manual"];
const ACS = ["Yes", "No"];
const SORT_OPTIONS = [
  { value: "default",    label: "Default Order" },
  { value: "price_asc",  label: "Price: Low → High" },
  { value: "price_desc", label: "Price: High → Low" },
  { value: "name_asc",   label: "Name: A → Z" },
  { value: "seats_desc", label: "Most Seats" },
];

// ─── NAVBAR ──────────────────────────────────────────────────
// function OcNavbar({ siteName, onBook }) {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const navigate = useNavigate();

//   const links = [
//     { label: "Home", path: "/" },
//     { label: "Fleet", path: "/our-cars" },
//     { label: "Modify Reservation", path: "/modify-reservetion" },
//     { label: "About", path: "/about-us" },
//     { label: "Gallery", path: "/gallery" },
//     { label: "Faq", path: "/faqs" },
//     { label: "Contact", path: "/contact-us" },
//   ];

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=DM+Sans:wght@300;400;500;600&display=swap');
//       `}</style>

//       <nav className="oc-nav">
//         <div
//           className="oc-nav-logo"
//           onClick={() => navigate("/")}
//         >
//           Orisnz
//           <span>{siteName?.replace("Drive", "") || "-Fleet"}</span>
//         </div>

//         {/* Desktop Menu */}
//         <ul className="oc-nav-links">
//           {links.map((item) => (
//             <li key={item.label}>
//               <a
//                 href={item.path}
//                 className={item.label === "Fleet" ? "active" : ""}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   navigate(item.path);
//                 }}
//               >
//                 {item.label}
//               </a>
//             </li>
//           ))}
//         </ul>

//         <button
//           className="oc-nav-cta"
//           onClick={onBook}
//         >
//           Book Now
//         </button>

//         {/* Mobile Toggle */}
//         <button
//           className="oc-mobile-toggle"
//           onClick={() => setMenuOpen((o) => !o)}
//           aria-label="Toggle menu"
//         >
//           <span
//             style={
//               menuOpen
//                 ? { transform: "rotate(45deg) translate(5px,5px)" }
//                 : {}
//             }
//           />
//           <span
//             style={menuOpen ? { opacity: 0 } : {}}
//           />
//           <span
//             style={
//               menuOpen
//                 ? { transform: "rotate(-45deg) translate(5px,-5px)" }
//                 : {}
//             }
//           />
//         </button>
//       </nav>

//       {/* Mobile Menu */}
//       <div className={`oc-mobile-menu${menuOpen ? " open" : ""}`}>
//         {links.map((item) => (
//           <a
//             href={item.path}
//             key={item.label}
//             onClick={(e) => {
//               e.preventDefault();
//               navigate(item.path);
//               setMenuOpen(false);
//             }}
//           >
//             {item.label}
//           </a>
//         ))}

//         <button
//           className="oc-nav-cta"
//           onClick={() => {
//             setMenuOpen(false);
//             onBook();
//           }}
//         >
//           Book Now
//         </button>
//       </div>
//     </>
//   );
// }

// ─── CAR DETAIL MODAL ────────────────────────────────────────
function CarModal({ car, currency = "₹", onClose, onBook }) {
  // Close on backdrop click
  const handleBg = (e) => { if (e.target === e.currentTarget) onClose(); };

  const specs1 = [
    { icon:"👥", label:"Passengers",   val: car.car_passgrno },
    { icon:"🧳", label:"Luggage",      val: car.car_luggno },
    { icon:"🚪", label:"Doors",        val: car.car_doors },
    { icon:"⚙️", label:"Transmission", val: car.car_transmission },
    { icon:"❄️", label:"Air-Con",      val: car.car_airconditionr },
    { icon:"🔧", label:"Engine",       val: car.car_engcapacity ? `${car.car_engcapacity} cc` : "Electric" },
  ];
  const specs2 = [
    { icon:"🔒", label:"Central Lock",     val: car.car_cntralLocking },
    { icon:"🎵", label:"Stereo",           val: car.car_stereo },
    { icon:"💨", label:"Air Bags",         val: car.car_airbag },
    { icon:"🪟", label:"Electric Windows", val: car.car_elctricwindows },
    { icon:"🏎️", label:"Power Steering",  val: car.car_powrsteering },
    { icon:"📦", label:"Group",            val: car.group_name },
  ];

  return (
    <div className="oc-modal-bg" onClick={handleBg}>
      <div className="oc-modal">
        <div className="oc-modal-header">
          <h2>{car.car_name} <span style={{color:"var(--muted)",fontSize:".75em",fontFamily:"'DM Sans',sans-serif",fontWeight:400}}>— {car.cat_name}</span></h2>
          <button className="oc-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="oc-modal-body">
          <img src={getImg(car.car_image)} alt={car.car_name} className="oc-modal-img" />
          {car.car_desc && <p className="oc-modal-desc">{car.car_desc}</p>}
          <div className="oc-modal-grid">
            <div className="oc-modal-spec-group">
              <h4>Core Specs</h4>
              {specs1.map(s => (
                <div className="oc-modal-spec-row" key={s.label}>
                  <span className="icon">{s.icon}</span>
                  <span>{s.label}</span>
                  <span className="val">{s.val}</span>
                </div>
              ))}
            </div>
            <div className="oc-modal-spec-group">
              <h4>Features</h4>
              {specs2.map(s => (
                <div className="oc-modal-spec-row" key={s.label}>
                  <span className="icon">{s.icon}</span>
                  <span>{s.label}</span>
                  <span className="val">{s.val}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="oc-modal-footer">
          <div className="oc-modal-price">
            {currency} {getPrice(car) ?? "—"}<small>per day</small>
          </div>
          <button className="oc-modal-book" onClick={() => { onBook(car); onClose(); }}>
            Book This Car →
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── MAIN OUR CARS PAGE ───────────────────────────────────────
const PER_PAGE = 9;

export default function OurCars() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchState = location.state || {};

  const { data: groups,   loading: gLoading } = useFetch("/cargroup", mockCarGroups);
  const { data: settings }                    = useFetch("/settings", { site_name:"Orisnz-Fleet", currency:"₹" });

  const currency = settings?.currency || "₹";

  // ── FETCH CARS + PRICES THEN MERGE ───────────────────────────
  // Your /api/prices (tariff route) returns rows with car_id + price + duration_prices.
  // Cars API has no price field, so we join them here on the frontend.
  const [allVehicles, setAllVehicles] = useState([]);
  const [vLoading,    setVLoading]    = useState(true);

  useEffect(() => {
    const carsUrl   = `${API_BASE}/cars?limit=200`;
    const pricesUrl = `${API_BASE}/price`;            // mounted as /api/price in server.js

    Promise.all([
      fetch(carsUrl).then(r => r.json()).catch(() => mockVehicles),
      fetch(pricesUrl).then(r => r.json()).catch(() => []),
    ]).then(([carsRaw, pricesRaw]) => {
      // Normalise cars array
      const cars = Array.isArray(carsRaw)
        ? carsRaw
        : Array.isArray(carsRaw?.data)
          ? carsRaw.data
          : mockVehicles;

      // Normalise prices array
      const prices = Array.isArray(pricesRaw)
        ? pricesRaw
        : Array.isArray(pricesRaw?.data)
          ? pricesRaw.data
          : [];

      // Build a map: car_id → lowest base price from tbl_tariffs
      // Each tariff row looks like:
      //   { car_id, price, duration_prices: [{ discount, FromRentslab, ToRentslab }] }
      // We pick the minimum discounted price across all slabs for each car.
      const priceMap = {};
      prices.forEach(row => {
        const basePrice = parseFloat(row.price) || 0;
        if (!basePrice) return;

        // Find the minimum possible price considering all duration slabs
        let minPrice = basePrice;
        if (Array.isArray(row.duration_prices) && row.duration_prices.length) {
          row.duration_prices.forEach(slab => {
            const disc = parseFloat(slab.discount) || 0;
            const discounted = basePrice - (basePrice * disc / 100);
            if (discounted < minPrice) minPrice = discounted;
          });
        }

        const cid = row.car_id;
        // Keep the lowest price if a car appears in multiple seasons/periods
        if (!priceMap[cid] || minPrice < priceMap[cid]) {
          priceMap[cid] = Math.round(minPrice);
        }
      });

      // Merge price into each car object
      const merged = cars.map(car => ({
        ...car,
        price: priceMap[car.car_id] ?? null,   // null = "On Request"
      }));

      setAllVehicles(merged);
      setVLoading(false);
    });
  }, []);

  // ── FILTER STATE ──
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedTrans,  setSelectedTrans]  = useState([]);
  const [selectedAC,     setSelectedAC]     = useState([]);
  const [maxPrice,       setMaxPrice]       = useState(200);
  const [minSeats,       setMinSeats]       = useState(1);
  const [sort,           setSort]           = useState("default");
  const [page,           setPage]           = useState(1);
  const [modalCar,       setModalCar]       = useState(null);
  const gridRef = useRef(null);

  // derive max price ceiling from data
  const priceCeiling = allVehicles.length
    ? Math.max(...allVehicles.map(v => getPrice(v) || 0), 200)
    : 200;

  // ── FILTER ──
  const filtered = allVehicles.filter(v => {
    const price = getPrice(v) || 0;
    const seats = Number(v.car_passgrno) || 0;
    const grp   = v.group_name || v.cat_name || "";
    const trans = v.car_transmission || "";
    const ac    = v.car_airconditionr || "No";

    if (selectedGroups.length && !selectedGroups.includes(grp)) return false;
    if (selectedTrans.length  && !selectedTrans.some(t => trans.toLowerCase().includes(t.toLowerCase()))) return false;
    if (selectedAC.length     && !selectedAC.includes(ac))  return false;
    if (price > maxPrice)  return false;
    if (seats < minSeats)  return false;
    return true;
  });

  // ── SORT ──
  const sorted = [...filtered].sort((a, b) => {
    const pa = getPrice(a) || 0;
    const pb = getPrice(b) || 0;
    if (sort === "price_asc")  return pa - pb;
    if (sort === "price_desc") return pb - pa;
    if (sort === "name_asc")   return (a.car_name || "").localeCompare(b.car_name || "");
    if (sort === "seats_desc") return Number(b.car_passgrno) - Number(a.car_passgrno);
    return 0;
  });

  // ── PAGINATE ──
  const totalPages = Math.max(1, Math.ceil(sorted.length / PER_PAGE));
  const safePage   = Math.min(page, totalPages);
  const paginated  = sorted.slice((safePage - 1) * PER_PAGE, safePage * PER_PAGE);

  const goPage = (p) => {
    setPage(p);
    gridRef.current?.scrollIntoView({ behavior:"smooth", block:"start" });
  };

  // reset page on filter/sort change
  useEffect(() => { setPage(1); }, [selectedGroups, selectedTrans, selectedAC, maxPrice, minSeats, sort]);

  // ── GROUP OPTIONS (from API or derived) ──
  const groupOptions = (groups && groups.length)
    ? groups.map(g => g.group_name).filter(Boolean)
    : [...new Set(allVehicles.map(v => v.group_name || v.cat_name).filter(Boolean))];

  const toggleArr = (arr, setArr, val) =>
    setArr(prev => prev.includes(val) ? prev.filter(x => x !== val) : [...prev, val]);

  const clearFilters = () => {
    setSelectedGroups([]); setSelectedTrans([]); setSelectedAC([]);
    setMaxPrice(priceCeiling); setMinSeats(1); setSort("default");
  };

  const handleBook = (car) => {
    navigate("/our-cars2", {
      state: {
        ...searchState,
        car_id:    car.car_id,
        car_name:  car.car_name,
        group_id:  car.group_id,
        group_name:car.group_name,
        price:     getPrice(car),
      }
    });
  };

  const handleBookNow = () => navigate("/#bknengine");

  const isLoading = vLoading || gLoading;

  return (
    <>
      <style>{css}</style>
      <Navbar activePage="Fleet" siteName={settings?.site_name} onBook={handleBookNow}  />

      {/* ── HERO ── */}
      <div className="oc-hero">
        <div className="oc-hero-inner">
          <div className="oc-hero-label">Browse Our Fleet</div>
          <h1 className="oc-hero-title">Available <span>Vehicles</span></h1>
          <p className="oc-hero-desc">
            Choose from our curated selection of premium, economy, and adventure-ready vehicles.
            Every car is inspected, insured, and ready for your next journey.
          </p>
        </div>
      </div>

      {/* ── BOOKING CONTEXT STRIP ── */}
      {(searchState.pickup || searchState.pickupDate) && (
        <div className="oc-booking-strip">
          {searchState.pickup && <span>📍 <strong>{searchState.pickup}</strong>{searchState.dropoff && searchState.dropoff !== searchState.pickup ? ` → ${searchState.dropoff}` : ""}</span>}
          {searchState.pickupDate && <span>📅 <strong>{searchState.pickupDate}</strong>{searchState.returnDate ? ` → ${searchState.returnDate}` : ""}</span>}
          {searchState.driverAge && <span>👤 Age: <strong>{searchState.driverAge}</strong></span>}
          <button className="oc-modify-btn" onClick={() => navigate(-1)}>✏ Modify Search</button>
        </div>
      )}

      {/* ── BODY ── */}
      <div className="oc-layout">

        {/* ── SIDEBAR ── */}
        <aside className="oc-sidebar">
          <h3>
            Filters
            <button onClick={clearFilters}>Clear All</button>
          </h3>

          {/* Group / Category */}
          <div className="oc-filter-group">
            <span className="oc-filter-label">Vehicle Group</span>
            {groupOptions.map(g => (
              <label className="oc-filter-option" key={g}>
                <input type="checkbox" checked={selectedGroups.includes(g)} onChange={() => toggleArr(selectedGroups, setSelectedGroups, g)} />
                <span>{g}</span>
              </label>
            ))}
          </div>

          {/* Transmission */}
          <div className="oc-filter-group">
            <span className="oc-filter-label">Transmission</span>
            {TRANSMISSIONS.map(t => (
              <label className="oc-filter-option" key={t}>
                <input type="checkbox" checked={selectedTrans.includes(t)} onChange={() => toggleArr(selectedTrans, setSelectedTrans, t)} />
                <span>{t}</span>
              </label>
            ))}
          </div>

          {/* Air Conditioning */}
          <div className="oc-filter-group">
            <span className="oc-filter-label">Air Conditioning</span>
            {ACS.map(a => (
              <label className="oc-filter-option" key={a}>
                <input type="checkbox" checked={selectedAC.includes(a)} onChange={() => toggleArr(selectedAC, setSelectedAC, a)} />
                <span>{a === "Yes" ? "With A/C" : "Without A/C"}</span>
              </label>
            ))}
          </div>

          {/* Max Price */}
          <div className="oc-filter-group">
            <span className="oc-filter-label">Max Price / Day</span>
            <input
              type="range" min={0} max={priceCeiling} step={5}
              value={maxPrice} onChange={e => setMaxPrice(Number(e.target.value))}
              className="oc-filter-range"
            />
            <div className="oc-range-labels">
              <span>{currency} 0</span>
              <span style={{color:"var(--gold)",fontWeight:600}}>{currency} {maxPrice}</span>
              <span>{currency} {priceCeiling}</span>
            </div>
          </div>

          {/* Min Seats */}
          <div className="oc-filter-group">
            <span className="oc-filter-label">Min Seats</span>
            <input
              type="range" min={1} max={9} step={1}
              value={minSeats} onChange={e => setMinSeats(Number(e.target.value))}
              className="oc-filter-range"
            />
            <div className="oc-range-labels">
              <span>1</span>
              <span style={{color:"var(--gold)",fontWeight:600}}>{minSeats}+</span>
              <span>9</span>
            </div>
          </div>
        </aside>

        {/* ── MAIN ── */}
        <main className="oc-main" ref={gridRef}>
          <div className="oc-toolbar">
            <div className="oc-count">
              Showing <strong>{paginated.length}</strong> of <strong>{sorted.length}</strong> vehicles
            </div>
            <select className="oc-sort" value={sort} onChange={e => setSort(e.target.value)}>
              {SORT_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </div>

          {isLoading ? (
            <div style={{textAlign:"center",padding:"5rem 2rem",color:"var(--muted)"}}>
              <div style={{fontSize:"2.5rem",marginBottom:"1rem",animation:"spin 1s linear infinite"}}>⟳</div>
              <p>Loading vehicles…</p>
              <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
            </div>
          ) : paginated.length === 0 ? (
            <div className="oc-empty">
              <div className="oc-empty-icon">🚗</div>
              <h3>No Vehicles Found</h3>
              <p>Try adjusting your filters to see more options.</p>
              <button
                onClick={clearFilters}
                style={{marginTop:"1.5rem",background:"var(--gold)",color:"var(--dark)",fontWeight:700,padding:".65rem 1.8rem",border:"none",borderRadius:"8px",cursor:"pointer",fontSize:".9rem"}}
              >
                Clear Filters
              </button>
            </div>
          ) : (
            <div className="oc-grid">
              {paginated.map(car => {
                const price = getPrice(car);
                return (
                  <div className="oc-card" key={car.car_id}>
                    <div className="oc-card-img-wrap">
                      <img src={getImg(car.car_image)} alt={car.image_alt || car.car_name} loading="lazy" />
                      {car.badge && <div className="oc-card-badge">{car.badge}</div>}
                    </div>
                    <div className="oc-card-body">
                      <div className="oc-card-group">{car.group_name || car.cat_name}</div>
                      <div className="oc-card-name">{car.car_name}</div>
                      <div className="oc-card-brand">{car.car_brand}</div>
                      <div className="oc-card-specs">
                        {car.car_passgrno && <div className="oc-spec"><span className="oc-spec-icon">👥</span>{car.car_passgrno} Seats</div>}
                        {car.car_luggno   && <div className="oc-spec"><span className="oc-spec-icon">🧳</span>{car.car_luggno} Bags</div>}
                        {car.car_transmission && <div className="oc-spec"><span className="oc-spec-icon">⚙️</span>{car.car_transmission}</div>}
                        {car.car_airconditionr === "Yes" && <div className="oc-spec"><span className="oc-spec-icon">❄️</span>A/C</div>}
                        {car.car_doors && <div className="oc-spec"><span className="oc-spec-icon">🚪</span>{car.car_doors} Doors</div>}
                        {car.car_engcapacity > 0 && <div className="oc-spec"><span className="oc-spec-icon">🔧</span>{car.car_engcapacity} cc</div>}
                      </div>
                      {car.car_desc && <div className="oc-card-desc">{car.car_desc}</div>}
                      <div className="oc-card-footer">
                        <div className="oc-card-price">
                          {price ? `${currency} ${price}` : "On Request"}
                          {price && <small>per day</small>}
                        </div>
                        <div style={{display:"flex",gap:".5rem"}}>
                          <button className="oc-details-btn" onClick={() => setModalCar(car)}>Details</button>
                          <button className="oc-book-btn"    onClick={() => handleBook(car)}>Book</button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* ── PAGINATION ── */}
          {totalPages > 1 && (
            <div className="oc-pagination">
              <button className="oc-page-btn" onClick={() => goPage(safePage - 1)} disabled={safePage === 1}>‹</button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                <button key={p} className={`oc-page-btn${p === safePage ? " active" : ""}`} onClick={() => goPage(p)}>{p}</button>
              ))}
              <button className="oc-page-btn" onClick={() => goPage(safePage + 1)} disabled={safePage === totalPages}>›</button>
            </div>
          )}
        </main>
      </div>

      {/* ── DETAIL MODAL ── */}
      {modalCar && (
        <CarModal
          car={modalCar}
          currency={currency}
          onClose={() => setModalCar(null)}
          onBook={handleBook}
        />
      )}
    </>
  );
}